import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { fixedImage } from '../../utils';
import Logo from '../logo/Logo';

import swipe from '../../../content/media-library/icons/swipe.svg';

const Report = ({ title, img, link, linkText }) => (
  <div className="report">
    <div className="report__doc">
      <Logo />
      <span style={{ backgroundImage: `url(${img?.images?.fallback?.src})` }} className="report__img"></span>
    </div>
    <div className="report__content">
      <h4>{title}</h4>
      <p>
        <a href={link}>{linkText}</a>
      </p>
    </div>
  </div>
);

export const Reports = () => {
  const data = useStaticQuery(graphql`
    {
      allFile(
        filter: {
          relativePath: {
            regex: "/media-library/(hero-images/(fawcett-header.png|make-business-simple-header.jpg)|campaigns/make-money-equal-cover.jpg)/"
          }
        }
      ) {
        nodes {
          absolutePath
          childImageSharp {
            gatsbyImageData(height: 210, quality: 90, layout: FIXED)
          }
        }
      }
    }
  `);

  return (
    <section className="reports">
      <div className="reports__inner">
        <div className="reports__block reports__block--fixed">
          <h3>Reports</h3>
          <p className="reports__action">
            <img alt="Swipe graphic" src={swipe} />
            SWIPE
          </p>
        </div>
        <div className="reports__docs">
          <div className="reports__block reports__block--scroll">
            <Report
              title="Hers and His: Opening up the household budget"
              link="/reports/money-management-and-budgeting-in-households/"
              img={fixedImage(data, 'fawcett-header.png')}
              linkText="Read our Household budgeting report"
            />
            <Report
              title="#MakeBusinessSimple"
              link="/reports/make-business-simple/reduce-financial-admin/"
              img={fixedImage(data, 'make-business-simple-header.jpg')}
              linkText="Read about #MakeBusinessSimple"
            />
            <Report
              title="#MakeMoneyEqual"
              link="/campaign/makemoneyequal/"
              img={fixedImage(data, 'make-money-equal-cover.jpg')}
              linkText="Read about #MakeMoneyEqual"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reports;
